import React from 'react'

export default function ourworkPage() {
  return (
    <div className='ourwork-container'>

      
      <h1>A Hogy dolgozunk? oldal hamarosan frissülni fog!</h1>


      {/*
      <h1>Referenciáink</h1>
        <h2>M76 </h2>
        <p className='references-source'>Kép forrása: https://m76projekt.hu/ Elérés:2026.07.22.</p>
        <img src={m76} alt="m76" />
        
        <h2>Toperini</h2>
        <p className='references-source'>Kép forrása: https://navigatorvilag.hu/hir/cezc/ Elérés:2026.07.22.</p>
        <img src={toperini} alt="toperini" />
        
        <h2>Miskolc koronaszálló</h2>
        <p className='references-source'>Kép forrása: https://mcc.hu/hir/uj-fenyben-tundokolhet-a-miskolci-korona-szallo Elérés:2026.07.22.</p>
        <img src={mcc_miskolc} alt="mcc_miskolc" />
        
        <h2>Dorothea hotel</h2>
        <p className='references-source'>Kép forrása: https://bdpstgroup.hu/hotel-dorothea-en/ Elérés:2026.07.23.</p>
        <img src={dorothea} alt="dorothea" />
        */}
        
        
    </div>
  )
}
